import { render, staticRenderFns } from "./UcInvoiceBadge.yaml?vue&type=template&id=351f142b&component"
import script from "./UcInvoiceBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports